module.exports = {"id":"200278","name":"Santiago García","rating":"73","photo":"./data/images/photos/2/200278.png","club":{"name":"Toluca","logo":"./data/images/clubs/Toluca.png"},"positions":["DG","DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SantiagoGarcia0.json
// module id = 3826
// module chunks = 0